export default "__VITE_ASSET__DCLa_MDB__"